import { render, staticRenderFns } from "./DesktopClientIndicator.vue?vue&type=template&id=11f77f5f"
import script from "./DesktopClientIndicator.vue?vue&type=script&lang=js"
export * from "./DesktopClientIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports